




# Double-bind wrapper around nouislider

# Usage:
# <NoUISlider :values.sync="array_of_handle_values" :config="object" /> 

# Remarks:
# set() triggers update(), and update() triggers set(). This would cause mayhem,
# but the flags internal_update and external_update prevent endless loops and
# other weirdness.

import noUiSlider from 'nouislider'

export default
    props:
        # The nouislider configuration, passed to nouislider.create()
        config:
            type: Object
            required: true
        # The current values of the slider
        values:
            type: Array
            required: true
        # (Optional) id of the slider. If not provided, a random is used.
        id:
            type: String
            required: false

    data: ->
        slider: null
        internal_update: false
        external_update: false
    
    computed:
        slider_id: ->
            return if @id then @id else @generateId()

    watch:
        values: (newVal, oldVal) ->
            if not @internal_update
                @external_update = true
                @slider.noUiSlider.set(newVal)
                @external_update = false
            @internal_update = false

    mounted: ->
        @slider = document.getElementById(@slider_id)
        @config.start = @values
        noUiSlider.create(@slider, @config)
        @slider.noUiSlider.on('update', @update)

    beforeDestroy: ->
        @slider.noUiSlider.off()

    methods:
        generateId: ->
            return 'vue-nouislider-' + Math.random().toString(36).substring(2)

        update: (values) ->
            if not @external_update
                @internal_update = true
                @$emit('update:values', values)
